module.exports = __webpack_public_path__ + "static/media/icon-phone.24010241.png";